import { useMutation, useQuery } from "react-query";

import { API_STORAGE_KEY } from "../../../constants/constant";
import AccessService from "../../../ApiServices/access.service";
import { notification } from "../../../util/notificationHelper";
import notificationService from "../../../util/notification.service";
import { LookUpApiService, MediaService, PortalService } from "../../../ApiServices";

const moduleName = API_STORAGE_KEY.ACCESS;

export const accessKeys = {
    accessList: (id, payload) => [moduleName, "LIST", id, payload],
    accessDetails: (id: any) => [moduleName, "DETAILS", id]
};

function useAccessListing(id, payload) {
    return useQuery(accessKeys.accessList(id, payload), async () => {
        const { data, ok, response } = await AccessService.getAccessListing({ id: id, payload });
        if (ok) {
            return data;
        } else {
            notificationService.error(response?.message);
            throw new Error(response?.message);
        }
    });
}

function useGetCategoryList() {
    return useQuery(API_STORAGE_KEY.ACCESS_CATEGORY_LIST, async () => {
        const { data, ok, response } = await AccessService.getCategoryList();
        if (ok) {
            return data?.categories?.map((item) => {
                return {
                    ...item,
                    key: String(item?.id)
                };
            });
        } else {
            notificationService.error(response?.message);
            throw new Error(response?.message);
        }
    });
}

function useUploadMedia() {
    return useMutation(async (payload) => {
        const { data, ok, response } = await MediaService.uploadMedia(payload);
        if (ok) {
            // onSuccess(data);
            return data;
        } else {
            notificationService.error("Logo", response?.message);
            throw new Error(response?.message);
        }
    });
}

const useDeleteContent = (onSuccess) => {
    return useMutation((id) => AccessService.deleteContent(id), {
        onSuccess,
        onError: (err) => {
            throw err;
        }
    });
};

const useDeleteAccessCategory = (onSuccess) => {
    return useMutation(async (payload) => {
        const { data, ok, response } = await PortalService.deleteAccessCategory(payload?.id);
        if (ok) {
            onSuccess();
            return data;
        } else {
            notification.failed("Delete", response?.message);
            throw new Error(response?.message);
        }
    });
};

const useChangeAccessCategoryOrder = (onSuccess) => {
    return useMutation(async (payload) => {
        const { data, ok, response } = await PortalService.changeAccessCategoryOrder(payload);
        if (ok) {
            onSuccess();
            return data;
        } else {
            notificationService.error(response?.message);
            throw new Error(response?.message);
        }
    });
};

function useUpdateAccessCategory(onSuccess) {
    return useMutation(async (payload) => {
        const { data, ok, response } = await PortalService.updateAccessCategory({ id: payload.id, ...payload });
        if (ok) {
            onSuccess();
            return data;
        } else {
            notificationService.error(response?.message);
            throw new Error(response?.message);
        }
    });
}

function useUpdateContent(onSuccess) {
    return useMutation(async (payload) => {
        const { data, ok, response } = await AccessService.updateAccessContent({ id: payload.id, ...payload });
        if (ok) {
            onSuccess();
            return data;
        } else {
            notificationService.error(response?.message);
            throw new Error(response?.message);
        }
    });
}

function useGetCategoryMedia() {
    return useQuery(API_STORAGE_KEY.GET_CATEGORY_MEDIA, async () => {
        const { data, ok, response } = await LookUpApiService.getCategoryMedia();
        if (ok) {
            return data;
        } else {
            notificationService.error(response?.message);
            throw new Error(response?.message);
        }
    });
}

export const useUploadResource = (onSuccess) => {
    return useMutation(async (payload) => {
        const { data, ok, response } = await MediaService.uploadResource(payload);
        if (ok) {
            return data?.id;
        } else {
            notificationService.error(response?.message);
            throw new Error(response?.message);
        }
    });
}; 

function useAddAccessContent(onSuccess) {
    return useMutation(async (payload) => {
        const { data, ok, response } = await AccessService.addAccessContent(payload);
        if (ok) {
            notification.addContent();
            onSuccess();
            return data;
        } else {
            notificationService.error(response?.message);
            throw new Error(response?.message);
        }
    });
}

function useAddAccessCategory(onSuccess) {
    return useMutation(async (payload) => {
        const { data, ok, response } = await PortalService.addAccessCategory(payload);
        if (ok) {
            onSuccess();
            notificationService.success(`Category Added Succesfully.`, "", true);
            return data;
        } else {
            notificationService.error(`${response?.message}.`, "", true);
            throw new Error(response?.message);
        }
    });
}

function useGetAccessById(id: any) {
    return useQuery(
        accessKeys.accessDetails(id),
        async () => {
            const { ok, data, response } = await AccessService.getAccessById(id);
            if (ok) {
                return data;
            }
        },
        { enabled: !!id }
    );
}


export {
    useAccessListing,
    useGetCategoryList,
    useAddAccessCategory,
    useAddAccessContent,
    useDeleteContent,
    useDeleteAccessCategory,
    useUpdateAccessCategory,
    useChangeAccessCategoryOrder,
    useUploadMedia,
    useUpdateContent,
    useGetCategoryMedia,
    useGetAccessById
};
